export default __webpack_public_path__ + "static/media/next_icon.f464250d.svg";